import { makeStyles } from "@material-ui/core/styles"

export default makeStyles(theme => ({
  // https://stackoverflow.com/a/11267268/8062659
  cellFit: {
    width: "1%",
    whiteSpace: "nowrap"
  },

  grey: {
    color: theme.palette.grey[400]
  }
}))
